import { DeepReadonly, IApplyUniConfig } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export enum DefaultDashboardTabIds {
  LEADS = 'Leads',
  APPLIED = 'Applied',
  DRAFT_OFFERS = 'Draft', // TODO ENROLY-3304: Remove after data migration completes
  CONDITIONAL = 'Conditional',
  UNCONDITIONAL = 'Unconditional',
  COMPLETED = 'Completed',
  CLOSED = 'Closed',
}

const applyUniConfig: IApplyUniConfig = {
  // TODO: Where and how do we define which variables are available to these "templates"?
  offerLetterStartTemplate: `We are delighted to issue you {conditionTypeWithArticle} offer to study {courseName} starting {intakeIdLabel}.`,
  offerLetterEndTemplate: `Admissions Team`,
  scholarships: [],
  termsAndConditionsUrl: 'https://www.enroly.com',
  privacyPolicyUrl: 'https://www.enroly.com',
  privacyPolicyConsentWording: {
    subtitle: 'Our privacy policy and how it affects you',
    header:
      'I consent to the processing of sensitive data (e.g., health, ethnicity) to support my application and for monitoring purposes',
    buttonLabel: 'Privacy policy',
    bodyText:
      'The information provided will be used to assess your eligibility and progress your application, in accordance with the {universityName} {privacyPolicyUrl}',
  },
  termsAndConditionConsentWording: {
    subtitle: "Read and consent to the University's terms and conditions",
    header: 'Terms & conditions',
    buttonLabel: 'Terms & conditions',
    bodyText: 'I consent to the {universityName}',
  },
  welcomeScreen: {
    title: 'Begin your application',
    content: `Using this app you will be able to complete your application for undergraduate and postgraduate courses at the university.\n\nIn this process you will be asked a series of questions and given a recommended set of documents to be uploaded in advance of your application to a course or programme offered by the university.\n\nThe list of documents and guidelines provided in this process do not constitute legal advice. The purpose is to speed up your application process.\n\nWe recommend that you have a photo or scan of your academic certificate or transcript as this information is used as part of your application, but you can get started without them.`,
  },
  rejectionReasons: {
    entryCriteriaNotMet: '',
    failedAcademicAssessment: '',
    failedCredibilityAssessment: '',
    fraudulentApplication: '',
    courseClosure: '',
    courseFull: '',
    unableToOfferCourse: '',
    deadlineHasPassed: '',
    closedByApplicant: '',
    wrongApplicationForm: '',
    failedPreCasInterview: '',
    failedComplianceInterview: '',
    negativeQualificationVerification: '',
    duplicateApplication: '',
    inactiveApplication: '',
    regionExclusiveToAgent: '',
    other: '',
  },
  // New configuration flags with default values (all fields visible by default) (commented intentionally)
  // disableFundingTuitionFeeQuestion: false,
  // disableFundingMaintenanceQuestion: false,
  // disableFundingWorkQuestion: false,
  // disableDeclarationTask: false,
  // disableDeclarationInterruptionQuestion: false,
  // disableDeclarationConvictionQuestion: false
};

export const defaultApplyUniConfig: DeepReadonly<IApplyUniConfig> = deepFreeze(applyUniConfig);
